// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"501":"bc98253f","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"501":"d13bf505216111a2","974":"99bee77068fc507b","1713":"3aa6c6e7c43ab634","4316":"da7517a88118b074","6457":"b8c8a6d0bcffa4b7","9839":"97db545449e006dc"}[chunkId] + ".js";
};